import { ErrorBoundary } from './components/ErrorBoundary';
import { useRoute } from './state/route';
import { Dashboard } from './workspaces/Dashboard';
import { ProjectShell } from './workspaces/ProjectShell';

export function App() {
  const [route, navigate] = useRoute();
  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#main"
        onClick={(e) => {
          e.preventDefault();
          document.getElementById('main')?.focus();
        }}
        className="sr-only z-50 rounded-md bg-accent-600 px-3 py-2 text-sm font-medium text-white focus:not-sr-only focus:fixed focus:top-2 focus:left-2"
      >
        Skip to main content
      </a>
      <header className="flex items-center justify-between gap-3 border-b border-zinc-800 bg-zinc-950/90 px-4 py-3 sm:px-6">
        <a href="#/" className="flex items-center gap-2 font-semibold tracking-tight">
          <svg aria-hidden="true" viewBox="0 0 32 32" className="size-7">
            <rect width="32" height="32" rx="7" fill="#18181b" />
            <path d="M6 20c3-8 5-8 7 0s4 8 7 0 4-8 6-4" fill="none" stroke="#a78bfa" strokeWidth="3" strokeLinecap="round" />
          </svg>
          <span>SonicForge Studio</span>
        </a>
        <nav aria-label="Main">
          <a
            href="#/"
            aria-current={route.name === 'dashboard' ? 'page' : undefined}
            className="rounded-md px-3 py-1.5 text-sm text-zinc-300 hover:bg-zinc-800 aria-[current=page]:text-white"
          >
            Projects
          </a>
        </nav>
      </header>
      <main id="main" tabIndex={-1} className="flex flex-1 flex-col outline-none">
        <ErrorBoundary label="The studio">
          {route.name === 'dashboard' ? (
            <Dashboard navigate={navigate} />
          ) : (
            <ProjectShell key={route.projectId} projectId={route.projectId} tab={route.tab} navigate={navigate} />
          )}
        </ErrorBoundary>
      </main>
      <footer className="border-t border-zinc-900 px-4 py-2 text-center text-xs text-zinc-400">
        Personal use · data stays in this browser
      </footer>
    </div>
  );
}
